import { Component, ViewChild } from '@angular/core';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { DecimalPipe } from '@angular/common';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../services/shared.service';
import { OpenPaylineDetailsArgs, PaylineType } from '../../../models/payroll';
import { PayrollManagement } from '../../../tools/payroll-management';

@Component({
  selector: 'app-cell-renderer',
  templateUrl: './cell-renderer.component.html',
  styleUrls: ['./cell-renderer.component.css'],
  standalone: false
})
export class CellRendererComponent {
  public params: any;
  public disabled: boolean;
  // static: false since this element has ngIf directive
  @ViewChild('moreActionsDropdown', { static: false })
  moreActionsDropdown: NgbDropdown;

  private closeMoreActionsSubscription: Subscription;

  constructor(
    private decimalPipe: DecimalPipe,
    private payrollMgmt: PayrollManagement,
    private sharedService: SharedService
  ) {
    this.closeMoreActionsSubscription = this.sharedService.closeMoreActionsPopup.subscribe(() => {
      if (this.moreActionsDropdown?.close) {
        this.moreActionsDropdown.close();
      }
    });
  }

  public agInit(params: any): void {
    this.params = params;
    const data = this.params.data;
    // show cursor: not-allow to let user know this field is not editabled
    // based on column key existence in the row model
    // or if the row is loading/validating
    if (typeof params.column.colDef.editable == 'function') {
      this.disabled = !params.column.colDef.editable(params);
    } else {
      this.disabled = !params.column.colDef.editable;
    }
  }

  public ngOnDestroy(): void {
    this.closeMoreActionsSubscription.unsubscribe();
  }

  public afterGuiAttached(params?: IAfterGuiAttachedParams): void {}

  public hasValue() {
    if (this.params.isPlaceholder) {
      return this.params.placeholder;
    } else {
      return this.params.value;
    }
  }

  public formatPlaceholder() {
    if (this.params.placeholder == null) {
      return '---';
    }

    if (this.params.mode == 'text') {
      return this.params.placeholder;
    }

    return this.format(this.params.placeholder);
  }

  public formatNumber() {
    if (this.params.isPlaceholder) {
      return this.formatPlaceholder();
    }

    if (!this.params.value && this.params.value !== 0) {
      return '';
    }

    return this.format(this.params.value);
  }

  public format(value) {
    const d = this.params.decimals;

    if (d != undefined && d > 2) {
      // if more than 2 decimals are specified, use decimal range starting with 2
      return this.decimalPipe.transform(value, `1.2-${d}`);
    } else if (d != undefined && d <= 2) {
      // no decimal range. either 0 or 1 decimals
      return this.decimalPipe.transform(value, `1.${d}-${d}`);
    } else {
      // no decimal length given, default to 2
      return this.decimalPipe.transform(value, '1.2-2');
    }
  }

  // emit event to payroll grid component to open payline details
  public openPaylineDetails(params) {
    const args = new OpenPaylineDetailsArgs(
      params.data.RowId,
      params.data.PaylineId,
      params.data.PersonId,
      params.rowIndex,
      params.data.NeedsCalculation,
      params.data.IsDirty,
      !this.payrollMgmt.isPaylineEditable(params.data.PaylineType)
    );

    this.sharedService.openPaylineDetails.next(args);
  }
}
